import { ApiCallsFactory, LocalPersistence } from "@factories/index"
// global URL
const url = '/property/guestrooms'
const postUrl = '/property/guestroom/uniqueamenities'

// getting the session data
const getSession = async () => {
  const get_session = new LocalPersistence('session')
  const session = await get_session.getSessionPersistence()
  return session
}

const getUniqueRoomData = async () => {
  const currentSession = await getSession()
  const getService = new ApiCallsFactory(`${url}?supplier=${currentSession?.supplier}&propertyid=${currentSession?.propertyId}`,currentSession.token)
  const response = await getService.getData()
  return response
}

// post call
const postUniqueRoom = async( body: object ) => {
  try {
    const currentSession = await getSession()
    const postBody = {
      supplier: currentSession.supplier,
      propertyId: currentSession.propertyId,
      property: {
        guestrooms: {
          guestroom:[
            body
          ]
        }
      }
    }
    const postService = new ApiCallsFactory(postUrl, currentSession.token, postBody)
    const response = await postService.postData()
    return response
  } catch (error) {
    return error
  }
}



export {
  getUniqueRoomData,
  postUniqueRoom
}
